import DemographicInfoContent from './DemographicInfoContent';

export default DemographicInfoContent;
